import React from "react"
import PropTypes from "prop-types"
import "../../../styles/layouts"
import Modal from "react-bootstrap/Modal"
import dayOfWeeks from "../../Utils/day_of_week"
import ToggleArrayField from "./ToggleArrayField"
import BusinessHourField from "./BusinessHourField"

const HolidayField = (props) => {
  const findIndex = props.holidays.findIndex((h) => h.dayOfWeek == props.wday)
  const currentHolidayIndex = findIndex == -1 ? undefined : findIndex
  return (
    <ToggleArrayField
      fields={{ name: props.name, onChange: props.onChange }}
      index={currentHolidayIndex}
      body={{ dayOfWeek: props.wday }}
      disabled={props.isAllday}
      label="定休日"
    />
  )
}

const AlldayField = (props) => {
  const findIndex = props.businessHours.findIndex(
    (h) => h.dayOfWeek == props.wday && !h.openingTime && !h.closingTime
  )
  const currentAlldayIndex = findIndex == -1 ? undefined : findIndex
  return (
    <ToggleArrayField
      fields={{ name: props.name, onChange: props.onChange }}
      index={currentAlldayIndex}
      body={{ dayOfWeek: props.wday, openingTime: null, closingTime: null }}
      disabled={props.isHoliday}
      label="24時間営業"
    />
  )
}

const BusinessHourModal = (props) => {
  const isHoliday =
    props.holidays.find((h) => h.dayOfWeek == props.wday) != undefined
  const isAllday =
    props.businessHours.find(
      (h) => h.dayOfWeek == props.wday && !h.openingTime
    ) != undefined

  return (
    <React.Fragment>
      <Modal show={props.wday !== null} onHide={props.onHide}>
        <Modal.Header closeButton>
          <Modal.Title>{dayOfWeeks[props.wday]}の営業時間・定休日</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <BusinessHourField
            name="businessHours"
            isHoliday={isHoliday}
            isAllday={isAllday}
            {...props}
          />
        </Modal.Body>
        <Modal.Footer>
          <HolidayField name="holidays" isAllday={isAllday} {...props} />
          <AlldayField name="businessHours" isHoliday={isHoliday} {...props} />
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  )
}
BusinessHourModal.propTypes = {
  wday: PropTypes.string,
  businessHours: PropTypes.array,
  holidays: PropTypes.array,
  onChange: PropTypes.func,
  onHide: PropTypes.func,
  touched: PropTypes.object,
}
export default BusinessHourModal
